import { render, staticRenderFns } from "./_base-dot.vue?vue&type=template&id=650fb0ab&scoped=true&"
import script from "./_base-dot.vue?vue&type=script&lang=js&"
export * from "./_base-dot.vue?vue&type=script&lang=js&"
import style0 from "./_base-dot.vue?vue&type=style&index=0&id=650fb0ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650fb0ab",
  null
  
)

export default component.exports